"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MusicContentCenterConfiguration = exports.Music = exports.ClimaxSegment = exports.MvProperty = exports.MusicCacheInfo = exports.MUSIC_CACHE_STATUS_TYPE = exports.MusicChartInfo = exports.MusicContentCenterStateReason = exports.PreloadState = exports.MusicPlayMode = void 0;
var MusicPlayMode;
(function (MusicPlayMode) {
    MusicPlayMode[MusicPlayMode["kMusicPlayModeOriginal"] = 0] = "kMusicPlayModeOriginal";
    MusicPlayMode[MusicPlayMode["kMusicPlayModeAccompany"] = 1] = "kMusicPlayModeAccompany";
    MusicPlayMode[MusicPlayMode["kMusicPlayModeLeadSing"] = 2] = "kMusicPlayModeLeadSing";
})(MusicPlayMode || (exports.MusicPlayMode = MusicPlayMode = {}));
var PreloadState;
(function (PreloadState) {
    PreloadState[PreloadState["kPreloadStateCompleted"] = 0] = "kPreloadStateCompleted";
    PreloadState[PreloadState["kPreloadStateFailed"] = 1] = "kPreloadStateFailed";
    PreloadState[PreloadState["kPreloadStatePreloading"] = 2] = "kPreloadStatePreloading";
    PreloadState[PreloadState["kPreloadStateRemoved"] = 3] = "kPreloadStateRemoved";
})(PreloadState || (exports.PreloadState = PreloadState = {}));
var MusicContentCenterStateReason;
(function (MusicContentCenterStateReason) {
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonOk"] = 0] = "kMusicContentCenterReasonOk";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonError"] = 1] = "kMusicContentCenterReasonError";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonGateway"] = 2] = "kMusicContentCenterReasonGateway";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonPermissionAndResource"] = 3] = "kMusicContentCenterReasonPermissionAndResource";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonInternalDataParse"] = 4] = "kMusicContentCenterReasonInternalDataParse";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonMusicLoading"] = 5] = "kMusicContentCenterReasonMusicLoading";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonMusicDecryption"] = 6] = "kMusicContentCenterReasonMusicDecryption";
    MusicContentCenterStateReason[MusicContentCenterStateReason["kMusicContentCenterReasonHttpInternalError"] = 7] = "kMusicContentCenterReasonHttpInternalError";
})(MusicContentCenterStateReason || (exports.MusicContentCenterStateReason = MusicContentCenterStateReason = {}));
class MusicChartInfo {
}
exports.MusicChartInfo = MusicChartInfo;
var MUSIC_CACHE_STATUS_TYPE;
(function (MUSIC_CACHE_STATUS_TYPE) {
    MUSIC_CACHE_STATUS_TYPE[MUSIC_CACHE_STATUS_TYPE["MUSIC_CACHE_STATUS_TYPE_CACHED"] = 0] = "MUSIC_CACHE_STATUS_TYPE_CACHED";
    MUSIC_CACHE_STATUS_TYPE[MUSIC_CACHE_STATUS_TYPE["MUSIC_CACHE_STATUS_TYPE_CACHING"] = 1] = "MUSIC_CACHE_STATUS_TYPE_CACHING";
})(MUSIC_CACHE_STATUS_TYPE || (exports.MUSIC_CACHE_STATUS_TYPE = MUSIC_CACHE_STATUS_TYPE = {}));
class MusicCacheInfo {
}
exports.MusicCacheInfo = MusicCacheInfo;
class MvProperty {
}
exports.MvProperty = MvProperty;
class ClimaxSegment {
}
exports.ClimaxSegment = ClimaxSegment;
class Music {
}
exports.Music = Music;
class MusicContentCenterConfiguration {
}
exports.MusicContentCenterConfiguration = MusicContentCenterConfiguration;
